import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.SwiperJpA');
    const { locale } = useRouter();
    const [listA, setListA] = useState([
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786823358/7_1.jpg'
                    : locale == 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720166369525/%E5%8D%95%E6%9C%BA%E7%BB%84%E5%90%88.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719052203195/c1.jpg',
            h5:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786822802/7_1_M.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720166487759/Frame%201000008427.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719052224362/c2.jpg',
            upTitle: t('item1_t'),
            subtitle: t('item1_l'),
            desc: t('item1_r'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786822982/7_2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850681251/a2.jpg',
            h5:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786823164/7_2_M.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851206424/b2.jpg',
            upTitle: t('item2_t'),
            subtitle: t('item2_l'),
            desc: t('item2_r'),
        },
        {
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786823945/7_3.jpg'
                    : locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1720166600363/Effortless%20portability%2C%20space-efficient%20design.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850696128/a3.jpg',
            h5List:
                locale === 'cn'
                    ? [
                          'https://websiteoss.ecoflow.com/upload/image/1737786824325/7_3_1_M.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1737786824135/7_3_2_M.jpg',
                      ]
                    : [
                          locale === 'jp'
                              ? 'https://websiteoss.ecoflow.com/upload/image/1720166668423/Frame%201000008471.jpg'
                              : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851258647/b3-1.jpg',
                          'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851270379/b3-2.jpg',
                      ],
            upTitle: t('item3_t'),
            subtitle: t('item3_l'),
            desc: t('item3_r'),
        },
        {
            //isChangeImg2: true,
            pc:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786823543/7_4.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055675644/bb2.jpeg',
            //pc2: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718850771044/a4-2.jpg',
            h5:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737786823736/7_4_M.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037036923/c3%20(1).jpg',
            //h52: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718851374294/b4-2.jpg',
            upTitle: t('item4_t'),
            subtitle: t('item4_l'),
            desc: t('item4_r'),
        },
    ]);
    return (
        <div id="dp3-teaser-E13" className={`Smoothly dp3-teaser-E GtmModuleData-section`} data-section-id={'dp3-SwiperJpA'} data-section-title={t('title')}>
            <div className="dp3-module-box comp-module">
                <div className="dp3-title">{t('title')}</div>
            </div>
            <EfSwiperLevel2 list={listA} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
